module.exports = __webpack_public_path__ + "static/media/amazon.70a431a0.png";